/* @ngInject */

export default (SwitchReviewProduct, SwitchCompareProduct) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function SwitchProduct(switchReviewProducts, switchCompareProducts) {
    this.switchReviewProducts = switchReviewProducts;
    this.switchCompareProducts = switchCompareProducts;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  SwitchProduct.Blank = function () {
    return SwitchProduct.Build({
      switchReviewProducts: [],
      switchCompareProducts: []
    });
  };
  SwitchProduct.Build = function (data) {
    return new SwitchProduct(
      _.map(_.compact(data.switchReviewProducts), (switchReviewProduct) =>
        SwitchReviewProduct.Build(switchReviewProduct)
      ),
      _.map(_.compact(data.switchCompareProducts), (switchCompareProduct) =>
        SwitchCompareProduct.Build(switchCompareProduct)
      )
    );
  };

  return SwitchProduct;
};
